import { render, staticRenderFns } from "./DisputeSubmit.vue?vue&type=template&id=4a80a9fe&scoped=true"
import script from "./DisputeSubmit.vue?vue&type=script&lang=js"
export * from "./DisputeSubmit.vue?vue&type=script&lang=js"
import style0 from "./DisputeSubmit.vue?vue&type=style&index=0&id=4a80a9fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a80a9fe",
  null
  
)

export default component.exports